import { clearAllAnalyticsQuestionHistory } from '@/services/client/analytics/questionHistorySession'
import { clearAllAnalyticsProgramSelection } from './analyticsProgramSelectionStorage'

/** Clears private analytics state at an authentication boundary, never server history. */
export function clearClientAnalyticsEphemeralState({
  preservePreferences = false,
}: { preservePreferences?: boolean } = {}): void {
  clearAllAnalyticsQuestionHistory()
  // Impersonation handoff/rollback retains existing member-scoped program preferences.
  // Logout, expiry, and ordinary authentication remove them.
  if (!preservePreferences) clearAllAnalyticsProgramSelection()
}
